var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBlueRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 97,
    fill: "none",
    viewBox: "0 0 1440 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFE5EC",
    d: "M-.193.663L1439.84 96.794H-.193V.663z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E8DD",
    d: "M-1.065.767H1440.81v96.027L-1.065.767z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBlueRectangle);
export default __webpack_public_path__ + "static/media/GreenBlueRectangle.78efc4da7f2b08b28f4f69fce6f143c4.svg";
export { ForwardRef as ReactComponent };